<div *ngIf="adrsLst && adrsLst.length > 0">
    <div class="m-4">
        <button mat-flat-button [color]="'primary'" class="m-r-10" (click)="addNewAddress()">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:plus-circle'"></mat-icon>
            <span class="sm:inline-block ml-2">Address</span>
        </button>
    </div>
    <!-- <ds-loading *ngIf="loader === true"></ds-loading> -->
    <div class="flex flex-col w-full m-2 cntntBgrnd">
        <div class="relative flex flex-col   flex-0 ng-tns-c266-4 ">
                <div class="grid grid-cols-1  sm:grid-cols-2 lg:grid-cols-4  w-full">
                    <div *ngFor="let c of adrsLst" class=" m-2 shadow p-4 bg-white rounded-lg ">
                        <div class="font-medium p-1">{{c.lctn_type_nm}}
                            <span>
                                <mat-icon class="icon-size-4 cursor-pointer" style="float: right;"
                                    [svgIcon]="'heroicons_solid:pencil-alt'" (click)="edtAddrss(c)">
                                </mat-icon>
                            </span>
                        </div>
                        <ng-container *ngIf="c.dr_nu">
                            <div class="flex flex-row items-center p-1">
                                <div class="text-xs text-secondary break-all capitalize">
                                    {{c.dr_nu}},
                                    <span *ngIf="c.adrs1_tx">{{c.adrs1_tx}}</span>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container>
                            <div class="flex flex-row items-center p-1">
                                <div class="text-xs text-secondary break-all capitalize"
                                    *ngIf="c.adrs2_tx">{{c.adrs2_tx}},
                                    <span *ngIf="c.ctry_nm">{{c.ctry_nm}}</span>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container>
                            <div class="flex flex-row items-center p-1">
                                <div class="text-xs text-secondary break-all capitalize">
                                    {{c.dstrt_nm}},<span>{{c.ste_nm}}</span></div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="c.lat && c.lng">
                            <div
                                class="flex flex-row items-center text-center text-xs p-1 text-blue-500">
        
                                <a target="_blank"
                                    href="https://maps.google.com/?q={{c.lat}},{{c.lng}}"
                                    class="text-center">
                                    View Location
                                </a>
        
                            </div>
                        </ng-container>
                    </div>
                </div>
        </div>
    </div>
</div>
